import { useRecoilState } from 'recoil';
import { settingState } from '@/state/settingState';

export const useServiceType = () => {
  const [setting] = useRecoilState(settingState);

  return setting?.serviceType;
};
